// extracted by mini-css-extract-plugin
export default {"formHeading":"FM-z","form":"GM-z","submitBtn":"HM-z","disabled":"IM-z","input":"JM-z","error":"KM-z","submitMsg":"LM-z","signIn":"MM-z"};